import { getData, removeData, setData } from "./CookieUtiles";
import axios from "axios";
const apiUrl_Alagappa = process.env.REACT_APP_BASE_URL_ALAGAPPA_AGENCIES;

export const createToken = async (navigate, setLoggedIn) => {
  removeData("AccessToken");

  try {
    const refreshToken = getData("RefreshToken");

    if (!refreshToken) {
      setLoggedIn(false);
      console.log("No refresh token found, redirecting to login");
      navigate("/login");
      return false;
    }

    const response = await axios.get(`${apiUrl_Alagappa}create-account-token`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${refreshToken}`,
      },
    });

    if (response.statuscode === 401 || response.statuscode === 500) {
      removeData("RefreshToken");
      setLoggedIn(false);
      navigate("/login");
      return false;
    }

    if (response.status === 201 && response.data.results?.accessToken) {
      window.location.reload();
      setData("AccessToken", response.data.results.accessToken);

      return response.data.results.accessToken;
    }
  } catch (error) {
    if (error) {
      const status = parseInt(error.response.data?.statuscode, 10);

      if (status === 401 || status === 500) {
        setLoggedIn(false);
        navigate("/login");
      }
    }

    return false;
  }
};

export const verifiedToken = async (navigate) => {
  try {
    const accessToken = getData("AccessToken");

    const response = await fetch(`${apiUrl_Alagappa}auth-account-token`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (response.status === 401) {
      const tokenCreated = await createToken(navigate);
      if (!tokenCreated) {
        navigate("/login");
      }
      return;
    }

    const data = await response.json();
    if (response.ok && data.status && data.code === "VERIFIED") {
      setData("Email", data.results.email);
      setData("RollNo", data.results.role);
    } else {
      const tokenCreated = await createToken(navigate);
      if (!tokenCreated) {
        navigate("/login");
      }
    }
  } catch (error) {
    navigate("/login");
  }
};
